module.exports = __webpack_public_path__ + "assets/img/detail7.f4363cce.png";